// src/views/Organizations/OrganizationLayout.jsx
//
// La superficie de una organización. Usa el mismo shell que configuración —el
// menú lateral no era el problema— pero vive fuera de ella.
//
// Configuración es la sesión: tú y la cuenta en la que estás. A una organización
// se entra desde su lista y puede ser cualquiera de las que perteneces, no
// necesariamente la de tu contexto. Tener las dos cosas en un mismo menú
// mezclaba dos modos de direccionar: dos grupos que decían "ahora" y uno que
// decía "cualquiera".
import React from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SettingsShell from '../Settings/SettingsShell';
import useOrgRole from '../../hooks/useOrgRole';
import { useOrganizations } from '../../hooks/useOrganizations';
import { organizationGroups } from '../../lib/settingsNav';

export default function OrganizationLayout() {
  const { orgId } = useParams();
  const location = useLocation();
  const { t } = useTranslation();
  const { organizations = [] } = useOrganizations();
  const { canManage, settled } = useOrgRole(orgId);

  const organization = organizations.find((o) => o.id === orgId) || null;

  const groups = organizationGroups({
    orgId,
    orgName: organization?.name,
    // Mientras el rol no se sepa se asume que no administra: ofrecer secciones
    // que el backend va a rechazar es peor que revelarlas medio segundo tarde.
    canManage: settled ? canManage : false,
    t,
  });

  return (
    <SettingsShell groups={groups} active={location.pathname}>
      <Outlet />
    </SettingsShell>
  );
}
